import { render, staticRenderFns } from "./disclaimers-table.vue?vue&type=template&id=34af34e6"
import script from "./disclaimers-table.vue?vue&type=script&lang=js"
export * from "./disclaimers-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports